// Small, dependency-free string helpers shared across features.

/** Upper-case the first character, leaving the rest untouched. */
export function capitalize(s: string): string {
  return s.length === 0 ? s : s.charAt(0).toUpperCase() + s.slice(1);
}

/**
 * Splits a full name on its first run of whitespace: `'Jane van Dyke'` →
 * `{ firstName: 'Jane', lastName: 'van Dyke' }`. Either part is `''` when
 * absent, so callers decide whether an empty part is sent or omitted.
 */
export function splitFullName(name: string | null | undefined): {
  firstName: string;
  lastName: string;
} {
  const trimmed = (name ?? '').trim();
  const match = /^(\S+)\s+([\s\S]+)$/.exec(trimmed);
  return match ? { firstName: match[1], lastName: match[2] } : { firstName: trimmed, lastName: '' };
}

/** Cut `s` to `max` characters, ending in "…" when shortened. */
export function truncate(s: string, max: number): string {
  return s.length > max ? `${s.slice(0, max - 1)}…` : s;
}
